import tagEn from "./locales/en.json";

export const TAG_NS = "tag" as const;

export const TagTranslations = {
  en: {
    [TAG_NS]: {
      ...tagEn,
    },
  },
};
